import type { ListItem } from "../../components/List/List"
import { CourierEntity } from "../Courier/CourierEntity"
import { MemoryClass } from "./MemoryClass"

export class CourierMemory extends MemoryClass<CourierEntity> {
  setList = (list: CourierEntity[]) => {
    this.listData = list
  }

  protected cloneEntity(item: CourierEntity): CourierEntity {
    return new CourierEntity({ ...item })
  }

  protected getItemId(item: CourierEntity): number {
    return -1
  }

  getListCards = (all: boolean): ListItem[] => {
    var cards: ListItem[] = []
    let count = 0

    this.listData.forEach((ss) => {
      cards.push(this.getCard(ss, count))
    })

    count++

    return cards
  }

  getCard(e: CourierEntity, count: number): ListItem {
    return {
      isDisable: false,
      id: -1,
      title: "",
      linkImage: "",
      index: count,
      dataFilter: [],
      children: <></>,
      body: <></>,
    }
  }
}
